'use strict';

class PaymentFailureController {
    /*@ngInject*/
    constructor ($mdDialog, $stateParams, $state, orderStore, utils, payment, auth, $q) {
        "ngInject";
        _.extend(this, {
            name: 'completion',
            $stateParams: $stateParams,
            $state: $state,
            $mdDialog: $mdDialog,
            orderStore: orderStore,
            payment: payment,
            utils: utils,
            auth: auth,
            $q: $q
        });

        this.orderLoader = this.orderStore.getOrderWithBill($stateParams.orderId)
            .then(
                (orderAndBill) => {
                    this.order = orderAndBill.order;
                    this.bill = orderAndBill.bill;
                    woopra.track("payment-failed", {
                        order_id : this.order.id,
                        order_status : this.order.status
                    });
                    this.timeSlotIndex = _.indexBy(this.timeSlots, 'value');
                    this.formattedMoveDate = moment(this.order.order_time * 1000).format('DD MMMM YYYY');
                    this.orderNo = this.utils.getOrderNo(this.order.id);

                    this.flatOrderItems = this.utils.flattenOrderItems(this.order.order_items, this.order.item_stats, this.order.vehicle_statistics, this.order.property_type);
                    this.itemColumns = this.getItemColumnsFromInventory(this.flatOrderItems);

                    this.propertyTypeIndex = _.indexBy(this.propertyTypes, 'value');
                    this.timeSlotIndex = _.indexBy(this.timeSlots, 'value');

                    this.customer = this.auth.currentUser();
                },
                (error) => this.$q.reject(error)
            );
    }

    timeSlots = [
        {displayName: '8am - 10am', value: 'time_slot_1'},
        {displayName: '10am - 12pm', value: 'time_slot_2'},
        {displayName: '2pm - 4pm', value: 'time_slot_3'},
        {displayName: '4pm - 6pm', value: 'time_slot_4'}
    ]


    propertyTypes = [
        {displayName: '1 BHK', value: '1 BHK'},
        {displayName: '2 BHK', value: '2 BHK'},
        {displayName: '3 BHK', value: '3 BHK'},
        {displayName: '3+ BHK', value: '3+ BHK'},
        {displayName: 'Vehicle', value: 'VEHICLE'},
        {displayName: 'Items', value: 'ITEM'},
        {displayName: 'Duplex Villa', value: 'DUPLEX_VILLA'}
    ]

    getItemColumnsFromInventory (inventory) {
        let itemsInInventory = _(inventory)
            .map(item => this.utils.withDescriptionOf(item, 6))
            .value();

        return _(itemsInInventory)
            .sortBy(item => item.score)
            .groupBy(item => item.qualifiedName)
            .map((items, itemQualifiedName) => _.extend(this.utils.getItemColumn(itemQualifiedName, items, 6), {quantity: items.length}))
            .groupBy(item => this.utils.getRootNameOf(item, 2))
            .map((children, categoryName) => this.utils.withDescriptionOf({
                qualifiedName: categoryName,
                children: children
            }, 2))
            .sortBy(item => item.score)
            .map(category => {
                category.counts = {};
                category.counts[category.qualifiedName] = {size: _.sum(category.children, 'quantity')};
                category.package_status = _.every(category.children, {package_status: true});
                return category;
            })
            .groupBy(item => this.utils.getRootNameOf(item, 1))
            .map((children, categoryName) => this.utils.withDescriptionOf({
                qualifiedName: categoryName,
                children: children
            }, 1))
            .sortBy(category => this.utils.sortMajorCategories(category))
            .value();
    }

    goToOrders() {
        return this.$state.go('base.orders');
    }

    goToPayment() {
        return this.$state.go('base.payment', {orderId: this.order.id});
    }

}


export default PaymentFailureController;


// WEBPACK FOOTER //
// ./client/app/components/failure/failure.controller.js